import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const SchedulingAssistantTab = withSafeSuspense(lazy(
  async () => ({ default: (await import('./scheduling_assistant_tab')).SchedulingAssistantTab })
))
